import type { ChainFurnitureModel, UpdateChainFurnitureInput } from 'src/infrastructure/rest-api/api-types';

export const buildInventoryMasterDataReorderInputs = (rows: ChainFurnitureModel[]): UpdateChainFurnitureInput[] => {
    return rows.map((row, index) => ({
        id: row.id,
        furnitureTypeId: row.furnitureTypeId,
        name: row.name,
        description: row.description,
        sortOrder: index,
    }));
};
